(function () {
  function initHeaderSearchDropdown() {
    var searches = document.querySelectorAll('.header-search');
    if (!searches.length) {
      return;
    }

    var overlay = document.querySelector('#search-overlay');

    function anySearchOpen() {
      return document.querySelector('.header-search.is-open');
    }

    function openOverlay() {
      document.body.classList.add('search-overlay-active');
      if (overlay) {
        overlay.setAttribute('aria-hidden', 'false');
      }
    }

    function closeOverlayIfIdle() {
      if (anySearchOpen()) {
        return;
      }
      document.body.classList.remove('search-overlay-active');
      if (overlay) {
        overlay.setAttribute('aria-hidden', 'true');
      }
    }

    searches.forEach(function (search) {
      var input = search.querySelector('.header-search__input');
      var dropdown = search.querySelector('[data-search-dropdown]');
      var defaultPanel = search.querySelector('[data-search-default]');
      var resultsPanel = search.querySelector('[data-search-results]');
      if (!input || !dropdown) {
        return;
      }

      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-haspopup', 'true');

      var searchTimer = null;
      var activeRequest = 0;
      var conditionHandles = [
        'floaters',
        'age-related-macular-degeneration-amd',
        'glaucoma-ocular-express',
        'diabetic-retinopathy'
      ];

      function openDropdown() {
        search.classList.add('is-open');
        dropdown.setAttribute('aria-hidden', 'false');
        input.setAttribute('aria-expanded', 'true');
      }

      function closeDropdown() {
        search.classList.remove('is-open');
        dropdown.setAttribute('aria-hidden', 'true');
        input.setAttribute('aria-expanded', 'false');
      }

      function showDefaultPanel() {
        if (defaultPanel) {
          defaultPanel.hidden = false;
        }
        if (resultsPanel) {
          resultsPanel.hidden = true;
          resultsPanel.innerHTML = '';
        }
      }

      function showResultsPanel(html) {
        if (defaultPanel) {
          defaultPanel.hidden = true;
        }
        if (resultsPanel) {
          resultsPanel.hidden = false;
          resultsPanel.innerHTML = html;
        }
      }

      function buildSection(title, items, withThumbs) {
        if (!items.length) {
          return '';
        }
        var listItems = items
          .map(function (item) {
            var thumbHtml = '';
            if (withThumbs && item.image) {
              thumbHtml =
                '<img class="header-search__thumb" src="' +
                item.image +
                '" alt="' +
                item.title +
                '" loading="lazy" width="32" height="32">';
            }
            return '<li><a href="' + item.url + '">' + thumbHtml + item.title + '</a></li>';
          })
          .join('');
        return (
          '<div class="header-search__section">' +
          '<p class="header-search__title">' +
          title +
          '</p>' +
          '<ul class="header-search__list">' +
          listItems +
          '</ul>' +
          '</div>'
        );
      }

      function fetchSearchResults(query) {
        var currentRequest = ++activeRequest;

        var baseParams = {
          q: query,
          'resources[type]': 'product,collection,page',
          'resources[limit]': '6'
        };

        var paramSets = [
          Object.assign({}, baseParams, {
            'resources[options][fields]': 'title,body,product_type'
          }),
          baseParams
        ];

        function requestWithParams(params) {
          var url = new URL('/search/suggest.json', window.location.origin);
          Object.keys(params).forEach(function (key) {
            url.searchParams.append(key, params[key]);
          });

          return fetch(url.toString(), {
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json'
            }
          }).then(function (response) {
            if (!response.ok) {
              throw new Error('Search request failed');
            }
            return response.text();
          });
        }

        function parseResponse(text) {
          try {
            return JSON.parse(text);
          } catch (error) {
            return null;
          }
        }

        function handleData(data) {
          if (currentRequest !== activeRequest) {
            return;
          }
          var resources = (data && data.resources && data.resources.results) || {};
          var products = (resources.products || []).map(function (item) {
            return {
              title: item.title,
              url: item.url,
              image: item.image || item.featured_image || null
            };
          });

          var collections = (resources.collections || []).map(function (item) {
            return {
              title: item.title,
              url: item.url
            };
          });

          var pages = (resources.pages || []).filter(function (item) {
            return conditionHandles.indexOf(item.handle) !== -1;
          });
          var conditions = pages.map(function (item) {
            return {
              title: item.title,
              url: item.url
            };
          });

          var html =
            buildSection('Products', products, true) +
            buildSection('Collections', collections) +
            buildSection('Conditions', conditions);

          if (!html) {
            html =
              '<div class="header-search__section">' +
              '<p class="header-search__title">No results</p>' +
              '<ul class="header-search__list"><li>Hmm...no results for this search.</li></ul>' +
              '<div class="header-search__footer">' +
              '<a class="header-search__all" href="/collections/all">Browse all Products</a>' +
              '</div>' +
              '</div>';
          }

          showResultsPanel(html);
        }

        requestWithParams(paramSets[0])
          .then(function (text) {
            var data = parseResponse(text);
            if (!data) {
              throw new Error('Invalid JSON');
            }
            handleData(data);
          })
          .catch(function () {
            return requestWithParams(paramSets[1])
              .then(function (text) {
                var data = parseResponse(text);
                if (!data) {
                  throw new Error('Invalid JSON');
                }
                handleData(data);
              })
              .catch(function () {
                if (currentRequest !== activeRequest) {
                  return;
                }
                showResultsPanel(
                  '<div class="header-search__section">' +
                    '<p class="header-search__title">Search unavailable</p>' +
                    '<ul class="header-search__list"><li>Please try again.</li></ul>' +
                    '</div>'
                );
              });
          });
      }

      search.addEventListener('focusin', function () {
        openOverlay();
        openDropdown();
      });

      search.addEventListener('focusout', function (event) {
        if (!search.contains(event.relatedTarget)) {
          closeDropdown();
          closeOverlayIfIdle();
        }
      });

      input.addEventListener('click', function () {
        openOverlay();
        openDropdown();
        if (!input.value.trim()) {
          showDefaultPanel();
        }
      });
      input.addEventListener('input', function () {
        var query = input.value.trim();
        openOverlay();
        openDropdown();
        if (!query) {
          if (searchTimer) {
            clearTimeout(searchTimer);
          }
          showDefaultPanel();
          return;
        }
        if (searchTimer) {
          clearTimeout(searchTimer);
        }
        searchTimer = setTimeout(function () {
          fetchSearchResults(query);
        }, 200);
      });

      document.addEventListener('click', function (event) {
        if (!search.contains(event.target)) {
          closeDropdown();
          closeOverlayIfIdle();
        }
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeDropdown();
          closeOverlayIfIdle();
          input.blur();
        }
      });
    });
  }

  function initMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu) {
      return;
    }

    var openButtons = document.querySelectorAll('[data-mobile-menu-toggle]');
    var closeButtons = menu.querySelectorAll('[data-mobile-menu-close]');
    var overlay = menu.querySelector('[data-mobile-menu-overlay]');
    var panel = menu.querySelector('[data-mobile-menu-panel]');
    var body = document.body;

    function openMenu() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      body.classList.add('mobile-menu-open');
      openButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
      });
      if (panel) {
        panel.focus();
      }
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      body.classList.remove('mobile-menu-open');
      openButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (menu.classList.contains('is-open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeMenu);
    });

    if (overlay) {
      overlay.addEventListener('click', closeMenu);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }

  function initStickyFallback() {
    var header = document.querySelector('.site-header');
    if (!header) {
      return;
    }

    var topbar = document.querySelector('.header-topbar');
    var headerTop = header.offsetTop;
    var headerHeight = header.getBoundingClientRect().height;
    var ticking = false;

    function updateMeasurements() {
      headerTop = topbar ? topbar.getBoundingClientRect().height : header.offsetTop;
      headerHeight = header.getBoundingClientRect().height;
    }

    function apply() {
      ticking = false;
      var shouldFix = window.scrollY > headerTop;
      header.classList.toggle('is-fixed', shouldFix);
      if (topbar) {
        topbar.classList.toggle('is-hidden', shouldFix);
      }
      header.style.top = '';
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(apply);
      }
    }

    updateMeasurements();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      updateMeasurements();
      apply();
    });
    apply();
  }

  function initButtons() {
    var buttons = document.querySelectorAll('button');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        button.classList.add('is-clicked');
        setTimeout(function () {
          button.classList.remove('is-clicked');
        }, 200);
      });
    });
  }

  function initHeroCarousel() {
    var carousels = document.querySelectorAll('[data-hero-carousel]');
    if (!carousels.length) {
      return;
    }

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-hero-track]');
      var slides = carousel.querySelectorAll('[data-hero-slide]');
      var dots = carousel.querySelectorAll('[data-hero-dot]');
      if (!track || slides.length === 0) {
        return;
      }

      var index = 0;
      var intervalMs = parseInt(carousel.getAttribute('data-interval'), 10) || 0;
      var timer = null;

      if (prefersReducedMotion) {
        intervalMs = 0;
      }

      function update() {
        track.style.transform = 'translateX(' + -index * 100 + '%)';
        slides.forEach(function (slide, slideIndex) {
          slide.setAttribute('aria-hidden', slideIndex !== index);
        });
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      function goTo(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        update();
      }

      function startAutoplay() {
        if (!intervalMs) {
          return;
        }
        stopAutoplay();
        timer = window.setInterval(function () {
          goTo(index + 1);
        }, intervalMs);
      }

      function stopAutoplay() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var target = parseInt(dot.getAttribute('data-hero-dot'), 10);
          if (!isNaN(target)) {
            goTo(target);
            startAutoplay();
          }
        });
      });

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusout', startAutoplay);

      update();
      startAutoplay();
    });
  }

  function initCategoryCarousel() {
    var carousels = document.querySelectorAll('[data-category-carousel]');
    if (!carousels.length) {
      return;
    }

    carousels.forEach(function (carousel) {
      var viewport = carousel.querySelector('[data-carousel-viewport]');
      var track = carousel.querySelector('[data-carousel-track]');
      var progress = carousel.querySelector('[data-carousel-progress]');
      var thumb = carousel.querySelector('[data-carousel-thumb]');
      if (!viewport || !track || !progress || !thumb) {
        return;
      }

      var isDragging = false;
      var isProgressDragging = false;
      var startX = 0;
      var startScroll = 0;
      var dragMoved = false;
      var lastDragTime = 0;
      var dragThreshold = 6;
      var dragPointerId = null;
      var hasPointerCapture = false;
      var rafId = null;

      function updateProgress() {
        var maxScroll = viewport.scrollWidth - viewport.clientWidth;
        var trackWidth = progress.clientWidth;
        var ratio = maxScroll > 0 ? viewport.scrollLeft / maxScroll : 0;
        var thumbWidth = trackWidth * (viewport.clientWidth / viewport.scrollWidth || 0);

        thumbWidth = Math.max(thumbWidth, 48);
        thumbWidth = Math.min(thumbWidth, trackWidth);
        var maxThumbX = Math.max(trackWidth - thumbWidth, 0);
        var thumbX = maxThumbX * ratio;

        thumb.style.width = thumbWidth + 'px';
        thumb.style.transform = 'translate3d(' + thumbX + 'px, -50%, 0)';
        progress.setAttribute('aria-valuenow', Math.round(ratio * 100));
      }

      function requestUpdate() {
        if (rafId) {
          return;
        }
        rafId = window.requestAnimationFrame(function () {
          rafId = null;
          updateProgress();
        });
      }

      function setScrollFromPosition(clientX) {
        var rect = progress.getBoundingClientRect();
        var maxScroll = viewport.scrollWidth - viewport.clientWidth;
        if (maxScroll <= 0) {
          return;
        }
        var thumbWidth = thumb.getBoundingClientRect().width || 0;
        var usableWidth = Math.max(rect.width - thumbWidth, 1);
        var position = clientX - rect.left - thumbWidth / 2;
        var ratio = rect.width > 0 ? position / usableWidth : 0;

        ratio = Math.max(0, Math.min(1, ratio));
        viewport.scrollLeft = ratio * maxScroll;
      }

      viewport.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) {
          return;
        }
        isDragging = true;
        dragMoved = false;
        dragThreshold = event.pointerType === 'touch' ? 12 : 6;
        startX = event.clientX;
        startScroll = viewport.scrollLeft;
        dragPointerId = event.pointerId;
        hasPointerCapture = false;
      });

      viewport.addEventListener('pointermove', function (event) {
        if (!isDragging) {
          return;
        }
        var delta = event.clientX - startX;
        if (!dragMoved && Math.abs(delta) > dragThreshold) {
          dragMoved = true;
          viewport.classList.add('is-dragging');
          if (!hasPointerCapture && dragPointerId !== null) {
            viewport.setPointerCapture(dragPointerId);
            hasPointerCapture = true;
          }
        }
        if (dragMoved) {
          viewport.scrollLeft = startScroll - delta;
        }
      });

      function endDrag(event) {
        if (!isDragging) {
          return;
        }
        isDragging = false;
        if (dragMoved) {
          lastDragTime = Date.now();
        }
        viewport.classList.remove('is-dragging');
        if (hasPointerCapture) {
          viewport.releasePointerCapture(event.pointerId);
          hasPointerCapture = false;
        }
        dragPointerId = null;
      }

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);

      track.addEventListener('click', function (event) {
        if (Date.now() - lastDragTime < 200) {
          event.preventDefault();
          event.stopPropagation();
        }
      });

      progress.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) {
          return;
        }
        isProgressDragging = true;
        progress.setPointerCapture(event.pointerId);
        setScrollFromPosition(event.clientX);
      });

      progress.addEventListener('pointermove', function (event) {
        if (!isProgressDragging) {
          return;
        }
        setScrollFromPosition(event.clientX);
      });

      function endProgressDrag(event) {
        if (!isProgressDragging) {
          return;
        }
        isProgressDragging = false;
        progress.releasePointerCapture(event.pointerId);
      }

      progress.addEventListener('pointerup', endProgressDrag);
      progress.addEventListener('pointercancel', endProgressDrag);

      viewport.addEventListener('scroll', requestUpdate);
      window.addEventListener('resize', requestUpdate);

      updateProgress();
    });
  }

  function initProductCarousel() {
    var carousels = document.querySelectorAll('[data-product-carousel]');
    if (!carousels.length) {
      return;
    }

    carousels.forEach(function (carousel) {
      var viewport = carousel.querySelector('[data-product-carousel-viewport]');
      var track = carousel.querySelector('[data-product-carousel-track]');
      var prevButton = carousel.querySelector('[data-product-carousel-prev]');
      var nextButton = carousel.querySelector('[data-product-carousel-next]');
      if (!viewport || !track || !prevButton || !nextButton) {
        return;
      }

      var slides = track.querySelectorAll('[data-product-slide]');
      if (!slides.length) {
        prevButton.disabled = true;
        nextButton.disabled = true;
        return;
      }

      var currentPage = 0;
      var totalPages = 1;

      function getPerView() {
        if (window.matchMedia('(min-width: 990px)').matches) {
          return 3;
        }
        if (window.matchMedia('(min-width: 750px)').matches) {
          return 2;
        }
        return 1;
      }

      function updateButtons() {
        prevButton.disabled = currentPage <= 0;
        nextButton.disabled = currentPage >= totalPages - 1;
      }

      function syncPageFromScroll() {
        var pageWidth = viewport.clientWidth || 1;
        currentPage = Math.round(viewport.scrollLeft / pageWidth);
        currentPage = Math.max(0, Math.min(currentPage, totalPages - 1));
        updateButtons();
      }

      function goToPage(page, smooth) {
        currentPage = Math.max(0, Math.min(page, totalPages - 1));
        viewport.scrollTo({
          left: currentPage * viewport.clientWidth,
          behavior: smooth ? 'smooth' : 'auto'
        });
        updateButtons();
      }

      function updateLayout() {
        totalPages = Math.max(Math.ceil(slides.length / getPerView()), 1);
        currentPage = Math.min(currentPage, totalPages - 1);
        goToPage(currentPage, false);
      }

      prevButton.addEventListener('click', function () {
        goToPage(currentPage - 1, true);
      });

      nextButton.addEventListener('click', function () {
        goToPage(currentPage + 1, true);
      });

      viewport.addEventListener('scroll', syncPageFromScroll, { passive: true });
      window.addEventListener('resize', updateLayout);

      updateLayout();
    });
  }

  function initCollectionFiltersAutoSubmit() {
    var forms = document.querySelectorAll('.collection-filters__form');
    if (!forms.length) {
      return;
    }

    forms.forEach(function (form) {
      form.addEventListener('change', function () {
        form.submit();
      });
    });
  }

  function initCollectionFiltersMenu() {
    var menu = document.querySelector('[data-collection-filters-menu]');
    var openButtons = document.querySelectorAll('[data-collection-filters-toggle]');
    if (!menu || !openButtons.length) {
      return;
    }

    var closeButtons = menu.querySelectorAll('[data-collection-filters-close]');
    var overlay = menu.querySelector('[data-collection-filters-overlay]');
    var panel = menu.querySelector('[data-collection-filters-panel]');
    var body = document.body;

    function openMenu() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      body.classList.add('collection-filters-open');
      openButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
      });
      if (panel) {
        panel.focus();
      }
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      body.classList.remove('collection-filters-open');
      openButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (menu.classList.contains('is-open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeMenu);
    });

    if (overlay) {
      overlay.addEventListener('click', closeMenu);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }

  function initCollectionSort() {
    var selects = document.querySelectorAll('.collection-controls__select');
    if (!selects.length) {
      return;
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        if (select.hasAttribute('data-variant-select') || select.closest('form[data-product-form]')) {
          return;
        }
        if (select.form) {
          select.form.submit();
        }
      });
    });
  }

  function initProductGallery() {
    var thumbs = document.querySelectorAll('[data-product-thumbs]');
    if (!thumbs.length) {
      return;
    }

    thumbs.forEach(function (thumbGroup) {
      var frame = thumbGroup.closest('.product-media__gallery');
      if (!frame) {
        return;
      }

      var image = frame.querySelector('.product-media__image');
      if (!image) {
        return;
      }

      var thumbsWrap = frame.querySelector('.product-media__thumbs-wrap');

      function syncThumbsHeight() {
        if (!thumbsWrap) {
          return;
        }
        var frameEl = frame.querySelector('.product-media__frame');
        if (!frameEl) {
          return;
        }
        var frameHeight = frameEl.getBoundingClientRect().height;
        if (frameHeight > 0) {
          thumbsWrap.style.setProperty('--thumbs-max-height', Math.round(frameHeight) + 'px');
          thumbGroup.style.setProperty('--thumbs-max-height', Math.round(frameHeight) + 'px');
        }
      }

      window.addEventListener('resize', syncThumbsHeight);
      requestAnimationFrame(syncThumbsHeight);

      var isPointerDown = false;
      var startX = 0;
      var startY = 0;
      var startScrollLeft = 0;
      var startScrollTop = 0;
      var didDrag = false;
      var activePointerId = null;
      var pressedThumb = null;

      function startThumbDrag(event) {
        if (event.button !== 0) {
          return;
        }
        isPointerDown = true;
        didDrag = false;
        activePointerId = event.pointerId;
        pressedThumb = event.target.closest('.product-media__thumb');
        startX = event.clientX;
        startY = event.clientY;
        startScrollLeft = thumbGroup.scrollLeft;
        startScrollTop = thumbGroup.scrollTop;
        thumbGroup.classList.add('is-dragging');
        if (thumbGroup.setPointerCapture) {
          thumbGroup.setPointerCapture(activePointerId);
        }
      }

      thumbGroup.addEventListener('pointerdown', startThumbDrag, true);

      function selectThumb(button) {
        if (!button) {
          return;
        }

        var src = button.getAttribute('data-thumb-src');
        var alt = button.getAttribute('data-thumb-alt');
        if (!src) {
          return;
        }

        image.src = src;
        image.setAttribute('srcset', src);
        image.setAttribute('sizes', '100vw');
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');
        if (alt) {
          image.alt = alt;
        }

        var active = thumbGroup.querySelector('.product-media__thumb.is-active');
        if (active) {
          active.classList.remove('is-active');
        }
        button.classList.add('is-active');
      }

      thumbGroup.addEventListener('pointermove', function (event) {
        if (!isPointerDown) {
          return;
        }

        var deltaX = event.clientX - startX;
        var deltaY = event.clientY - startY;
        if (!didDrag && Math.hypot(deltaX, deltaY) > 4) {
          didDrag = true;
        }

        if (didDrag) {
          event.preventDefault();
          thumbGroup.scrollLeft = startScrollLeft - deltaX;
          thumbGroup.scrollTop = startScrollTop - deltaY;
        }
      });

      function endThumbDrag(event) {
        if (!isPointerDown) {
          return;
        }
        isPointerDown = false;
        thumbGroup.classList.remove('is-dragging');
        if (activePointerId !== null && thumbGroup.releasePointerCapture) {
          thumbGroup.releasePointerCapture(activePointerId);
        }
        if (!didDrag && event) {
          selectThumb(pressedThumb);
        }
        if (didDrag && event) {
          event.preventDefault();
        }
        activePointerId = null;
        pressedThumb = null;
      }

      thumbGroup.addEventListener('pointerup', endThumbDrag);
      thumbGroup.addEventListener('pointercancel', endThumbDrag);
      thumbGroup.addEventListener('mouseleave', endThumbDrag);

      thumbGroup.addEventListener('click', function (event) {
        if (didDrag) {
          event.preventDefault();
          event.stopPropagation();
          didDrag = false;
          return;
        }
        selectThumb(event.target.closest('.product-media__thumb'));
      });

      thumbGroup.querySelectorAll('.product-media__thumb').forEach(function (button) {
        button.addEventListener('click', function (event) {
          if (didDrag) {
            event.preventDefault();
            event.stopPropagation();
            didDrag = false;
            return;
          }
          selectThumb(button);
        });
      });
    });
  }

  function initQuantityControls() {
    var controls = document.querySelectorAll('[data-quantity-control]');
    if (!controls.length) {
      return;
    }

    controls.forEach(function (control) {
      var input = control.querySelector('input[type="number"]');
      if (!input) {
        return;
      }

      function clamp(value) {
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var maxAttr = input.getAttribute('max');
        var max = maxAttr ? parseInt(maxAttr, 10) : null;
        var next = isNaN(value) ? min : value;
        if (next < min) {
          next = min;
        }
        if (max !== null && next > max) {
          next = max;
        }
        return next;
      }

      control.addEventListener('click', function (event) {
        var button = event.target.closest('[data-qty-change]');
        if (!button) {
          return;
        }
        var delta = parseInt(button.getAttribute('data-qty-change') || '0', 10);
        var current = parseInt(input.value || '1', 10);
        input.value = clamp(current + delta);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      input.addEventListener('change', function () {
        input.value = clamp(parseInt(input.value, 10));
      });
    });
  }

  function initProductVariantUpdates() {
    var selects = document.querySelectorAll('[data-variant-select]');
    if (!selects.length) {
      return;
    }

    function formatMoney(cents) {
      var value = typeof cents === 'number' ? cents : parseInt(cents, 10);
      if (isNaN(value)) {
        return '';
      }
      var format = window.themeMoneyFormat || '${{amount}}';
      var normalized = (value / 100).toFixed(2);
      var noDecimals = Math.round(value / 100).toString();
      var commaValue = normalized.replace('.', ',');
      var commaNoDecimals = noDecimals.replace('.', ',');
      return format
        .replace('{{amount}}', normalized)
        .replace('{{amount_no_decimals}}', noDecimals)
        .replace('{{amount_with_comma_separator}}', commaValue)
        .replace('{{amount_no_decimals_with_comma_separator}}', commaNoDecimals);
    }

    function parseCents(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      var parsed = parseInt(value, 10);
      return isNaN(parsed) ? null : parsed;
    }

    function updateWidgetPrices(select) {
      var option = select.options[select.selectedIndex];
      if (!option) {
        return;
      }
      var variantPrice = parseCents(option.getAttribute('data-variant-price'));
      var compareAt = parseCents(option.getAttribute('data-variant-compare-at'));
      var subscriptionPrice = parseCents(option.getAttribute('data-subscription-price'));
      var root = select.closest('[data-product-root]') || document;
      var widget =
        root.querySelector('[data-joy-subscription-widget]') ||
        root.querySelector('.joy-subscription-widget') ||
        root.querySelector('.joy-subscription') ||
        root.querySelector('.joy-widget') ||
        root.querySelector('.Avada-Subscription__Block');

      if (!widget) {
        return;
      }

      var updated = false;
      var subscriptionTargets = widget.querySelectorAll(
        '[data-joy-subscription-price], [data-joy-price], .joy-subscription-price, .joy-subscribe-price, .joy-price--subscription'
      );
      if (subscriptionPrice !== null && subscriptionTargets.length) {
        subscriptionTargets.forEach(function (element) {
          element.textContent = formatMoney(subscriptionPrice);
        });
        updated = true;
      }

      var oneTimeTargets = widget.querySelectorAll(
        '[data-joy-one-time-price], [data-joy-regular-price], .joy-one-time-price, .joy-regular-price, .joy-price--onetime'
      );
      if (variantPrice !== null && oneTimeTargets.length) {
        oneTimeTargets.forEach(function (element) {
          element.textContent = formatMoney(variantPrice);
        });
        updated = true;
      }

      var compareTargets = widget.querySelectorAll('[data-joy-compare-price], .joy-compare-price, .joy-compare-at-price');
      if (compareAt !== null && variantPrice !== null && compareTargets.length) {
        compareTargets.forEach(function (element) {
          element.textContent = formatMoney(compareAt);
        });
        updated = true;
      }

      var avadaBlock = widget.querySelector('.Avada-Subscription__Block') || widget;
      if (avadaBlock && avadaBlock.querySelector('.Avada-SubscriptionOption')) {
        var oneTimeOption = avadaBlock.querySelector('[avada-data-value="one-time-purchase"]');
        var subscribeOption = avadaBlock.querySelector('[avada-data-value="subscribe-and-save"]');
        if (variantPrice !== null && oneTimeOption) {
          var oneTimePrice = oneTimeOption.querySelector('.Avada-Subscription__Price');
          if (oneTimePrice) {
            oneTimePrice.textContent = formatMoney(variantPrice);
            updated = true;
          }
        }
        if (subscribeOption) {
          var avadaSale = subscribeOption.querySelectorAll('.Avada-Price__Sale');
          var avadaRegular = subscribeOption.querySelectorAll('.Avada-Price__Regular');
          if (subscriptionPrice !== null && avadaSale.length) {
            avadaSale.forEach(function (element) {
              element.textContent = formatMoney(subscriptionPrice);
            });
            updated = true;
          }
          if (variantPrice !== null && avadaRegular.length) {
            avadaRegular.forEach(function (element) {
              element.textContent = formatMoney(variantPrice);
            });
            updated = true;
          }
          if (subscriptionPrice !== null && !avadaSale.length) {
            var fallbackSubscription = subscribeOption.querySelector('.Avada-Subscription__Price');
            if (fallbackSubscription) {
              fallbackSubscription.textContent = formatMoney(subscriptionPrice);
              updated = true;
            }
          }
        }
      } else {
        var avadaSaleFallback = widget.querySelectorAll('.Avada-Price__Sale');
        var avadaRegularFallback = widget.querySelectorAll('.Avada-Price__Regular');
        if (subscriptionPrice !== null && avadaSaleFallback.length) {
          avadaSaleFallback.forEach(function (element) {
            element.textContent = formatMoney(subscriptionPrice);
          });
          updated = true;
        }
        if (variantPrice !== null && avadaRegularFallback.length) {
          avadaRegularFallback.forEach(function (element) {
            element.textContent = formatMoney(variantPrice);
          });
          updated = true;
        }
      }

      if (updated) {
        return;
      }

      var currentPrice = subscriptionPrice !== null ? subscriptionPrice : variantPrice;
      if (currentPrice === null) {
        return;
      }

      var formattedCurrent = formatMoney(currentPrice);
      var formattedCompare = compareAt !== null ? formatMoney(compareAt) : formatMoney(variantPrice || currentPrice);
      var currencyPrefix = formattedCurrent.split(/\d/)[0].trim();
      var moneyRegex = currencyPrefix
        ? new RegExp('\\' + currencyPrefix + '\\s*\\d')
        : /\d/;

      var candidates = Array.prototype.slice
        .call(widget.querySelectorAll('span, strong, s, del, p, div'))
        .filter(function (element) {
          return element.childElementCount === 0 && moneyRegex.test(element.textContent || '');
        });

      if (!candidates.length) {
        return;
      }

      candidates.forEach(function (element) {
        var className = element.className || '';
        var isCompare =
          element.tagName === 'S' ||
          element.tagName === 'DEL' ||
          /compare|original|strike|was/i.test(className);
        if (isCompare && formattedCompare) {
          element.textContent = formattedCompare;
        }
      });

      var primary = candidates.find(function (element) {
        var className = element.className || '';
        return !/compare|original|strike|was/i.test(className) && element.tagName !== 'S' && element.tagName !== 'DEL';
      });

      if (primary) {
        primary.textContent = formattedCurrent;
      } else {
        candidates[0].textContent = formattedCurrent;
      }
    }

    selects.forEach(function (select) {
      var handler = function () {
        updateWidgetPrices(select);
      };
      select.addEventListener('change', handler);
      handler();
    });
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) {
      return;
    }

    var body = document.body;
    var overlay = drawer.querySelector('[data-cart-overlay]');
    var panel = drawer.querySelector('[data-cart-panel]');
    var closeButtons = drawer.querySelectorAll('[data-cart-close]');
    var itemsContainer = drawer.querySelector('[data-cart-items]');
    var emptyState = drawer.querySelector('[data-cart-empty]');
    var footer = drawer.querySelector('[data-cart-footer]');
    var countText = drawer.querySelector('[data-cart-count-text]');
    var subtotal = drawer.querySelector('[data-cart-subtotal]');
    var cartLink = document.querySelector('[data-cart-toggle]') || document.querySelector('.cart-link');
    var cartCount = document.querySelector('.cart-count');
    var addToCartForms = document.querySelectorAll('form[data-product-form]');

    if (panel) {
      panel.setAttribute('tabindex', '-1');
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      body.classList.add('cart-drawer-open');
      if (panel) {
        panel.focus();
      }
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      body.classList.remove('cart-drawer-open');
    }

    function formatMoney(cents) {
      var format = window.themeMoneyFormat || '${{amount}}';
      var value = (cents / 100).toFixed(2);
      var noDecimals = Math.round(cents / 100).toString();
      var commaValue = value.replace('.', ',');
      var commaNoDecimals = noDecimals.replace('.', ',');
      return format
        .replace('{{amount}}', value)
        .replace('{{amount_no_decimals}}', noDecimals)
        .replace('{{amount_with_comma_separator}}', commaValue)
        .replace('{{amount_no_decimals_with_comma_separator}}', commaNoDecimals);
    }

    function escapeHtml(text) {
      if (!text) {
        return '';
      }
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function updateCount(count) {
      if (cartCount) {
        cartCount.textContent = count;
      }
      if (countText) {
        countText.textContent = count + ' item' + (count === 1 ? '' : 's');
      }
    }

    function renderCart(cart) {
      var itemCount = cart.item_count || 0;
      updateCount(itemCount);
      if (subtotal) {
        subtotal.textContent = formatMoney(cart.total_price || 0);
      }

      if (emptyState) {
        emptyState.classList.toggle('is-hidden', itemCount > 0);
      }
      if (itemsContainer) {
        itemsContainer.classList.toggle('is-hidden', itemCount === 0);
      }
      if (footer) {
        footer.classList.toggle('is-hidden', itemCount === 0);
      }

      if (!itemsContainer) {
        return;
      }

      if (itemCount === 0) {
        itemsContainer.innerHTML = '';
        return;
      }

      var itemsHtml = cart.items
        .map(function (item, index) {
          var imageUrl = item.image || (item.featured_image && item.featured_image.url) || '';
          var imageHtml = imageUrl
            ? '<img class="cart-drawer__image" src="' +
              imageUrl +
              '" alt="' +
              escapeHtml(item.product_title || item.title) +
              '" loading="lazy">'
            : '';
          var subscription = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
          var frequency = subscription ? subscription.name : 'One-time purchase';
          var frequencyIcon = subscription
            ? '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6" aria-hidden="true">' +
              '<path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />' +
              '</svg>'
            : '';
          var finalPrice = item.final_price != null ? item.final_price : item.price;
          var originalPrice = item.original_price != null ? item.original_price : finalPrice;
          var priceLine =
            originalPrice > finalPrice
              ? '<span class="cart-drawer__price--original">' +
                formatMoney(originalPrice) +
                '</span><span class="cart-drawer__price--current">' +
                formatMoney(finalPrice) +
                '</span>'
              : '<span class="cart-drawer__price--current">' + formatMoney(finalPrice) + '</span>';
          return (
            '<div class="cart-drawer__item" data-cart-line="' +
            (index + 1) +
            '">' +
            '<div class="cart-drawer__media">' +
            imageHtml +
            '</div>' +
            '<div class="cart-drawer__details">' +
            '<div class="cart-drawer__title-row">' +
            '<p class="cart-drawer__title">' +
            escapeHtml(item.product_title || item.title) +
            '</p>' +
            '<button class="cart-drawer__remove" type="button" data-cart-remove="' +
            (index + 1) +
            '" aria-label="Remove item">' +
            '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">' +
            '<path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />' +
            '</svg>' +
            '</button>' +
            '</div>' +
            '<p class="cart-drawer__price">' +
            priceLine +
            '</p>' +
            '<p class="cart-drawer__frequency">' +
            frequencyIcon +
            escapeHtml(frequency) +
            '</p>' +
            '<div class="cart-drawer__actions">' +
            '<div class="cart-drawer__qty" data-cart-qty-control>' +
            '<button type="button" data-cart-qty="-1" aria-label="Decrease quantity">−</button>' +
            '<span class="cart-drawer__qty-value" data-cart-qty-value>' +
            item.quantity +
            '</span>' +
            '<button type="button" data-cart-qty="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<span class="cart-drawer__line-price">' +
            formatMoney(item.line_price) +
            '</span>' +
            '</div>' +
            '</div>' +
            '</div>'
          );
        })
        .join('');

      itemsContainer.innerHTML = itemsHtml;
    }

    function fetchCart() {
      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Cart request failed');
        }
        return response.json();
      });
    }

    function updateLineItem(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Cart update failed');
        }
        return response.json();
      });
    }

    function addToCart(form) {
      var formData = new FormData(form);
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      }).then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw data;
          });
        }
        return response.json();
      });
    }

    function syncCart() {
      return fetchCart().then(function (cart) {
        renderCart(cart);
        return cart;
      });
    }

    if (cartLink) {
      cartLink.addEventListener('click', function (event) {
        event.preventDefault();
        syncCart().then(function () {
          openDrawer();
        });
      });
    }

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    if (itemsContainer) {
      itemsContainer.addEventListener('click', function (event) {
        var qtyButton = event.target.closest('[data-cart-qty]');
        var removeButton = event.target.closest('[data-cart-remove]');
        var item = event.target.closest('[data-cart-line]');
        if (!item) {
          return;
        }
        var line = parseInt(item.getAttribute('data-cart-line'), 10);
        if (removeButton) {
          updateLineItem(line, 0).then(renderCart).then(openDrawer);
          return;
        }
        if (qtyButton) {
          var delta = parseInt(qtyButton.getAttribute('data-cart-qty'), 10);
          var valueEl = item.querySelector('[data-cart-qty-value]');
          var current = parseInt((valueEl && valueEl.textContent) || '1', 10);
          var next = current + delta;
          if (next < 1) {
            next = 1;
          }
          updateLineItem(line, next).then(renderCart);
        }
      });
    }

    addToCartForms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var submitButton = form.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.disabled = true;
        }
        addToCart(form)
          .then(function () {
            return syncCart();
          })
          .then(function () {
            openDrawer();
          })
          .catch(function () {
            form.submit();
          })
          .then(function () {
            if (submitButton) {
              submitButton.disabled = false;
            }
          });
      });
    });
  }

  function initCartPage() {
    var cartPage = document.querySelector('[data-cart-page]');
    if (!cartPage) {
      return;
    }

    var itemsContainer = cartPage.querySelector('[data-cart-page-items]');
    var subtotal = cartPage.querySelector('[data-cart-page-subtotal]');
    var countText = cartPage.querySelector('[data-cart-page-count]');
    var emptyState = cartPage.querySelector('[data-cart-page-empty]');
    var footer = cartPage.querySelector('[data-cart-page-footer]');
    var cartCount = document.querySelector('.cart-count');

    function formatMoney(cents) {
      var format = window.themeMoneyFormat || '${{amount}}';
      var value = (cents / 100).toFixed(2);
      var noDecimals = Math.round(cents / 100).toString();
      var commaValue = value.replace('.', ',');
      var commaNoDecimals = noDecimals.replace('.', ',');
      return format
        .replace('{{amount}}', value)
        .replace('{{amount_no_decimals}}', noDecimals)
        .replace('{{amount_with_comma_separator}}', commaValue)
        .replace('{{amount_no_decimals_with_comma_separator}}', commaNoDecimals);
    }

    function escapeHtml(text) {
      if (!text) {
        return '';
      }
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function updateCount(count) {
      if (cartCount) {
        cartCount.textContent = count;
      }
      if (countText) {
        countText.textContent = count + ' item' + (count === 1 ? '' : 's');
      }
    }

    function renderCartPage(cart) {
      var itemCount = cart.item_count || 0;
      updateCount(itemCount);
      if (subtotal) {
        subtotal.textContent = formatMoney(cart.total_price || 0);
      }
      if (emptyState) {
        emptyState.classList.toggle('is-hidden', itemCount > 0);
      }
      if (footer) {
        footer.classList.toggle('is-hidden', itemCount === 0);
      }
      if (!itemsContainer) {
        return;
      }
      if (itemCount === 0) {
        itemsContainer.innerHTML = '';
        return;
      }

      var itemsHtml = cart.items
        .map(function (item, index) {
          var imageUrl = item.image || (item.featured_image && item.featured_image.url) || '';
          var imageHtml = imageUrl
            ? '<img class="cart-drawer__image" src="' +
              imageUrl +
              '" alt="' +
              escapeHtml(item.product_title || item.title) +
              '" loading="lazy">'
            : '';
          var subscription = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
          var frequency = subscription
            ? subscription.name
            : item.variant_title && item.variant_title !== 'Default Title'
            ? item.variant_title
            : 'One-time purchase';
          var frequencyIcon = subscription
            ? '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6" aria-hidden="true">' +
              '<path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />' +
              '</svg>'
            : '';
          var finalPrice = item.final_price != null ? item.final_price : item.price;
          var originalPrice = item.original_price != null ? item.original_price : finalPrice;
          var priceLine =
            originalPrice > finalPrice
              ? '<span class="cart-drawer__price--original">' +
                formatMoney(originalPrice) +
                '</span><span class="cart-drawer__price--current">' +
                formatMoney(finalPrice) +
                '</span>'
              : '<span class="cart-drawer__price--current">' + formatMoney(finalPrice) + '</span>';
          var itemUrl = item.url || (item.product_handle ? '/products/' + item.product_handle : '#');
          return (
            '<div class="cart-drawer__item" data-cart-line="' +
            (index + 1) +
            '">' +
            '<div class="cart-drawer__media">' +
            imageHtml +
            '</div>' +
            '<div class="cart-drawer__details">' +
            '<div class="cart-drawer__title-row">' +
            '<div>' +
            '<p class="cart-drawer__title"><a href="' +
            escapeHtml(itemUrl) +
            '">' +
            escapeHtml(item.product_title || item.title) +
            '</a></p>' +
            '<p class="cart-drawer__frequency">' +
            frequencyIcon +
            escapeHtml(frequency) +
            '</p>' +
            '</div>' +
            '<button class="cart-drawer__remove" type="button" data-cart-remove="' +
            (index + 1) +
            '" aria-label="Remove item">' +
            '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6" aria-hidden="true">' +
            '<path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />' +
            '</svg>' +
            '</button>' +
            '</div>' +
            '<p class="cart-drawer__price">' +
            priceLine +
            '</p>' +
            '<div class="cart-drawer__actions">' +
            '<div class="cart-drawer__qty" data-cart-qty-control>' +
            '<button type="button" data-cart-qty="-1" aria-label="Decrease quantity">−</button>' +
            '<input type="number" name="updates[]" value="' +
            item.quantity +
            '" min="0" aria-label="Quantity for ' +
            escapeHtml(item.product_title || item.title) +
            '">' +
            '<button type="button" data-cart-qty="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<span class="cart-drawer__line-price">' +
            formatMoney(item.line_price) +
            '</span>' +
            '</div>' +
            '</div>' +
            '</div>'
          );
        })
        .join('');

      itemsContainer.innerHTML = itemsHtml;
    }

    function updateLineItem(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Cart update failed');
        }
        return response.json();
      });
    }

    function fetchCart() {
      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Cart request failed');
        }
        return response.json();
      });
    }

    if (itemsContainer) {
      itemsContainer.addEventListener('click', function (event) {
        var qtyButton = event.target.closest('[data-cart-qty]');
        var removeButton = event.target.closest('[data-cart-remove]');
        var item = event.target.closest('[data-cart-line]');
        if (!item) {
          return;
        }
        var line = parseInt(item.getAttribute('data-cart-line'), 10);
        if (removeButton) {
          updateLineItem(line, 0).then(renderCartPage);
          return;
        }
        if (qtyButton) {
          var delta = parseInt(qtyButton.getAttribute('data-cart-qty'), 10);
          var input = item.querySelector('input[type="number"]');
          var current = parseInt((input && input.value) || '1', 10);
          var next = current + delta;
          if (next < 0) {
            next = 0;
          }
          if (input) {
            input.value = next;
          }
          updateLineItem(line, next).then(renderCartPage);
        }
      });

      itemsContainer.addEventListener('change', function (event) {
        var input = event.target.closest('input[type="number"]');
        if (!input) {
          return;
        }
        var item = input.closest('[data-cart-line]');
        if (!item) {
          return;
        }
        var line = parseInt(item.getAttribute('data-cart-line'), 10);
        var next = parseInt(input.value || '0', 10);
        if (isNaN(next) || next < 0) {
          next = 0;
        }
        input.value = next;
        updateLineItem(line, next).then(renderCartPage);
      });
    }

    fetchCart().then(renderCartPage);
  }

  function initConditionsMenu() {
    var triggers = document.querySelectorAll('[data-conditions-toggle]');
    if (!triggers.length) {
      return;
    }

    function closeAll() {
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        var menu = trigger.closest('.conditions-menu');
        if (menu) {
          menu.classList.remove('is-open');
          menu.classList.remove('is-closed-manual');
        }
      });
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        var menu = trigger.closest('.conditions-menu');
        if (!menu) {
          return;
        }
        var isOpen = menu.classList.contains('is-open');
        closeAll();
        if (!isOpen) {
          menu.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        } else {
          menu.classList.add('is-closed-manual');
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('.conditions-menu')) {
        return;
      }
      closeAll();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAll();
      }
    });
  }

  function initCollectionRandomize() {
    if (!window.location.pathname.match(/^\/collections\/all\/?$/)) {
      return;
    }
    if (window.location.search.indexOf('sort_by=') !== -1) {
      return;
    }

    function shuffleGrid(grid) {
      if (!grid || grid.getAttribute('data-shuffled') === 'true') {
        return false;
      }
      var items = Array.prototype.slice.call(grid.children);
      if (items.length < 2) {
        return false;
      }

      // Fisher-Yates shuffle
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = items[i];
        items[i] = items[j];
        items[j] = temp;
      }

      var frag = document.createDocumentFragment();
      for (var k = 0; k < items.length; k++) {
        frag.appendChild(items[k]);
      }
      grid.appendChild(frag);
      grid.setAttribute('data-shuffled', 'true');
      return true;
    }

    function tryShuffle() {
      var grid = document.querySelector('[data-collection-grid]');
      if (shuffleGrid(grid)) {
        return true;
      }
      return false;
    }

    if (tryShuffle()) {
      return;
    }

    var observer = new MutationObserver(function () {
      if (tryShuffle()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    initStickyFallback();
    initHeaderSearchDropdown();
    initConditionsMenu();
    initMobileMenu();
    initButtons();
    initHeroCarousel();
    initCategoryCarousel();
    initProductCarousel();
    initCollectionFiltersAutoSubmit();
    initCollectionFiltersMenu();
    initCollectionSort();
    initCollectionRandomize();
    initProductGallery();
    initQuantityControls();
    initProductVariantUpdates();
    initCartDrawer();
    initCartPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
